import type { ReactNode } from 'react';
import { cn } from 'utils/classnames';
import { DISPOSITION_COLORS } from 'utils/constants';
import { ArrivalReceipt } from 'types';

interface Props {
  result: ArrivalReceipt;
  scanInput: ReactNode;
  dispositionSheet?: ReactNode;
}

export const ReceivingCallbackScreen = ({ result, scanInput, dispositionSheet }: Props) => {
  const colors = DISPOSITION_COLORS.CALLBACK;
  const subheading = result.responseMsg || 'Do not put away — handle callback';

  return (
    <div
      className={cn(
        '-mx-4 -mb-6 flex min-h-full flex-col items-center px-6 pb-6 pt-4',
        colors.gradient
      )}
    >
      <div className="mb-4 w-full">{scanInput}</div>

      <div className="mb-5 text-center">
        <p className="text-6xl font-black uppercase tracking-widest text-white leading-none drop-shadow-lg">
          CALLBACK
        </p>
        <p className="mt-2 text-4xl text-base font-bold uppercase tracking-wide text-white/90">
          {subheading}
        </p>
      </div>

      <h1 className="mb-4 text-base font-bold text-white">Tracking# {result.tracking_id}</h1>

      <div className="relative flex items-center justify-center my-12">
        <div className="animate-ping absolute inline-flex h-32 w-32 rounded-full bg-white/30" />
        <div className="animate-pulse relative">
          <div
            className={cn(
              'flex h-32 w-32 items-center justify-center rounded-full bg-white/20 ring-4 ring-white/40 ring-offset-4',
              colors.ringOffset
            )}
          >
            <span className="text-7xl">{colors.icon}</span>
          </div>
        </div>
      </div>

      {dispositionSheet}
    </div>
  );
};
